<template>
    <body class="bg-white" id="navigater-header">
        <CommonHeader></CommonHeader>

        <div class="max-w-7xl mx-auto py-3 px-4 sm:px-6 lg:px-8" id="app">
            <main @mouseover="hideUserMenu">
                <!--小念-->
                <section class="flex flex-col lg:flex-row justify-between items-center py-12">
                    <div class="text-center lg:text-left pt-4">
                        <h1 class="text-3xl lg:text-5xl font-bold mb-6">多模态、多行业</h1>
                        <h1 class="text-3xl lg:text-5xl font-bold mb-12">个性化智能心理健康解决方案</h1>
                        <p class="text-gray-660 mb-8 leading-loose">
                            「识心智能」成立于2024年，致力于为需要心理健康支持的个人和组织，打造一个<b>更理解、更包容、更高效</b>的<b>个性化</b>智能心理健康解决方案。<br />
                            识心智能的愿景是深化AI+心理在教育、医疗、心理咨询与治疗等多领域的深度融合，<br />
                            为<b>各行各业量身定制专属的智能心理健康解决方案</b>，以AI科技的力量促进心理健康事业的创新与繁荣发展。<br />
                        </p>
                    </div>

                </section>
                <section class="flex flex-col lg:flex-row justify-between items-center py-16 px-6 max-w-7xl mx-auto gap-12">
                    <div class="lg:w-5/12 flex justify-center">
                        <img src="@/assets/xiaonian.jpg" class="w-full max-w-md rounded-2xl shadow-lg object-cover aspect-[3/4]">
                    </div>

                    <div class="lg:w-7/12 space-y-8">
                        <div class="space-y-6">
                            <h2 class="text-4xl font-bold text-gray-800 leading-tight">
                                识心小念<br>
                                <span class="text-blue-600">你的专属AI心理疗愈师</span>
                            </h2>

                            <p class="text-lg text-gray-600 leading-relaxed">
                                在快节奏的现代生活中，情绪困扰与心理压力常如影随形。识心小念是一款温暖而智慧的AI心理疗愈伙伴，为你提供随时随地的情绪支持与科学疗愈指引。
                            </p>
                        </div>

                        <div class="bg-blue-50 p-6 rounded-xl space-y-4">
                            <h3 class="text-2xl font-semibold text-blue-700">核心价值</h3>

                            <div class="grid md:grid-cols-2 gap-6">
                                <div class="flex items-start space-x-3">
                                    <div class="flex-shrink-0 mt-1">
                                        <div class="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                                            <svg class="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div>
                                        <h4 class="font-medium text-gray-800">24小时倾听陪伴</h4>
                                        <p class="text-gray-600 text-sm mt-1">无需预约，随时倾诉你的烦恼，获得不带评判的回应</p>
                                    </div>
                                </div>

                                <div class="flex items-start space-x-3">
                                    <div class="flex-shrink-0 mt-1">
                                        <div class="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                                            <svg class="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div>
                                        <h4 class="font-medium text-gray-800">专业疗愈工具</h4>
                                        <p class="text-gray-600 text-sm mt-1">基于CBT、正念训练等心理学理论定制方案</p>
                                    </div>
                                </div>

                                <div class="flex items-start space-x-3">
                                    <div class="flex-shrink-0 mt-1">
                                        <div class="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                                            <svg class="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div>
                                        <h4 class="font-medium text-gray-800">安全匿名空间</h4>
                                        <p class="text-gray-600 text-sm mt-1">所有对话严格加密，保护你的隐私安全</p>
                                    </div>
                                </div>

                                <div class="flex items-start space-x-3">
                                    <div class="flex-shrink-0 mt-1">
                                        <div class="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center">
                                            <svg class="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div>
                                        <h4 class="font-medium text-gray-800">成长型AI助手</h4>
                                        <p class="text-gray-600 text-sm mt-1">通过深度学习，越来越贴合你的个性需求</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="border-t border-gray-100 pt-6">
                            <p class="text-gray-600 italic">
                                "无论是焦虑瞬间的即时疏导，还是长期自我探索的旅程，识心小念用科技的温度，守护你的内心晴空。"
                            </p>
                            <button @click="beginTrial" class="mt-6 px-8 py-3 bg-gradient-to-r from-blue-600 to-blue-400 text-white rounded-full font-medium shadow-lg hover:shadow-xl transition-all">
                                立即体验
                            </button>
                        </div>
                    </div>
                </section>
                <section class="py-8 bg-gradient-to-br from-blue-50 to-gray-50">
                    <div class="max-w-7xl mx-auto px-6">
                        <!-- 顶部标题和描述 -->
                        <div class="text-center lg:text-left mb-12">
                            <h2 class="text-4xl font-bold text-gray-800 leading-tight">
                                <span class="text-blue-600">技术为根</span>，疗愈为本
                            </h2>
                            <p class="text-lg text-gray-600 leading-relaxed max-w-3xl mx-auto lg:mx-0 mt-4">
                                在情绪疗愈领域，技术的力量在于更精准的理解、更温暖的回应。
                                识心小念依托前沿AI技术架构，将心理学专业性与大模型能力深度融合，为你提供真正「懂人心」的疗愈体验。
                            </p>
                        </div>

                        <!-- 图片和三个优势卡片的环绕布局 -->
                        <div class="relative">
                            <!-- 右上角图片 -->
                            <div class="lg:absolute lg:right-0 lg:top-0 lg:w-5/12 flex justify-center mb-8 lg:mb-0">
                                <img src="@/assets/youshi.jpg" class="w-full max-w-md rounded-2xl shadow-lg object-cover">
                            </div>

                            <!-- 三个优势卡片 - 现在会自然地环绕图片 -->
                            <div class="lg:pr-[calc(40%+2rem)] space-y-8">
                                <!-- 技术优势1 -->
                                <div class="feature-card flex space-x-6 p-6 bg-white rounded-xl shadow-card">
                                    <div class="flex-shrink-0 w-14 h-14 rounded-xl bg-blue-100 flex items-center justify-center">
                                        <span class="text-primary font-bold text-2xl">1</span>
                                    </div>
                                    <div class="space-y-3">
                                        <h3 class="text-xl font-semibold text-gray-800 flex items-center">
                                            <span class="mr-2">多模态情绪识别引擎</span>
                                            <i class="fa fa-arrow-right text-primary/60 text-sm"></i>
                                        </h3>
                                        <ul class="space-y-3 text-gray-600">
                                            <li class="flex items-start">
                                                <i class="fa fa-check-circle text-primary mt-1 mr-3"></i>
                                                <span>
                                                    <strong class="text-gray-800">实时情感分析：</strong>通过文本语义、表达节奏等多维度数据，动态识别你的情绪状态(如焦虑、低落或愤怒)，并自适应调整回应策略。
                                                </span>
                                            </li>
                                            <li class="flex items-start">
                                                <i class="fa fa-check-circle text-primary mt-1 mr-3"></i>
                                                <span><strong class="text-gray-800">上下文敏感交互：</strong>结合对话历史与即时反馈，避免机械应答，确保每一次互动都贴合你的当下需求。</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <!-- 技术优势2 -->
                                <div class="feature-card flex space-x-6 p-6 bg-white rounded-xl shadow-card">
                                    <div class="flex-shrink-0 w-14 h-14 rounded-xl bg-blue-100 flex items-center justify-center">
                                        <span class="text-primary font-bold text-2xl">2</span>
                                    </div>
                                    <div class="space-y-3">
                                        <h3 class="text-xl font-semibold text-gray-800 flex items-center">
                                            <span class="mr-2">大模型应用创新</span>
                                            <i class="fa fa-arrow-right text-primary/60 text-sm"></i>
                                        </h3>
                                        <ul class="space-y-3 text-gray-600">
                                            <li class="flex items-start">
                                                <i class="fa fa-check-circle text-primary mt-1 mr-3"></i>
                                                <span class="text-left">
                                                    <strong class="text-gray-800">RAG(检索增强生成)技术：</strong>
                                                    <span>
                                                        从海量心理学文献、疗愈案例库中智能检索信息，为你提供科学且个性化的建议(如CBT技巧、呼吸练习)，而非通用模板答案。
                                                    </span>
                                                </span>
                                            </li>
                                            <li class="flex items-start">
                                                <i class="fa fa-check-circle text-primary mt-1 mr-3"></i>
                                                <span class="text-left">
                                                    <strong class="text-gray-800">Agent智能体：</strong>
                                                    <span>
                                                        小念不仅是聊天机器人，更是具备「目标规划能力」的AI助手。它能主动拆分你的疗愈目标(如缓解社交焦虑)，并分阶段提供练习任务与进度追踪。
                                                    </span>
                                                </span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <!-- 技术优势3 -->
                                <div class="feature-card flex space-x-6 p-6 bg-white rounded-xl shadow-card">
                                    <div class="flex-shrink-0 w-14 h-14 rounded-xl bg-blue-100 flex items-center justify-center">
                                        <span class="text-primary font-bold text-2xl">3</span>
                                    </div>
                                    <div class="space-y-3">
                                        <h3 class="text-xl font-semibold text-gray-800 flex items-center">
                                            <span class="mr-2">持续进化的系统</span>
                                            <i class="fa fa-arrow-right text-primary/60 text-sm"></i>
                                        </h3>
                                        <ul class="space-y-3 text-gray-600">
                                            <li class="flex items-start">
                                                <i class="fa fa-check-circle text-primary mt-1 mr-3"></i>
                                                <span>
                                                    <strong class="text-gray-800">用户反馈闭环：</strong>通过匿名化数据与专业心理学家联合标注，持续优化情绪识别准确率与疗愈建议的有效性。
                                                </span>
                                            </li>
                                            <li class="flex items-start">
                                                <i class="fa fa-check-circle text-primary mt-1 mr-3"></i>
                                                <span><strong class="text-gray-800">安全与隐私优先：</strong>所有数据处理均符合医疗级加密标准，确保你的倾诉永远安全。</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 底部独占一行的blockquote -->
                        <div class="pt-8 mt-8 border-t border-gray-200">
                            <div class="text-gray-600 mr-0">
                                我们相信,真正的AI疗愈是技术与共情力的平衡。识心小念的每一次升级,只为更贴近那句<strong>承诺</strong>
                            </div>
                            <blockquote class="text-gray-700 italic text-xl mt-6 max-w-2xl mx-auto">
                                "你值得被认真倾听。"
                            </blockquote>
                        </div>
                    </div>
                </section>


                <section class="py-16" id="anchor-pro">
                    <div class="text-center mb-8">
                        <h1 class="text-4xl font-bold mb-5">“AI心理+” Pro</h1>
                        <h2 class="text-3xl font-bold">多模态 多行业应用场景</h2>
                    </div>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                        <div class="bg-white rounded-lg shadow-lg overflow-hidden">
                            <img alt="A person holding a game controller" class="w-full h-48 object-cover" height="400"
                                 src="@/assets/Education.png" width="600" />
                            <div class="p-4">
                                <h3 class="text-xl font-bold mb-2">教育</h3>
                                <p class="text-gray-600">Education</p>
                                <ul class="mt-2 text-gray-600">
                                    <li>智能备课理论助手</li>
                                    <li>教学与学情分析助手</li>
                                    <li>心理赋能教学创新助手</li>
                                    <li>校园心理健康助手</li>
                                    <li>家校社协同沟通助手</li>
                                </ul>
                            </div>
                        </div>
                        <div class="bg-white rounded-lg shadow-lg overflow-hidden">
                            <img alt="A person using a smartphone" class="w-full h-48 object-cover" height="400"
                                 src="@/assets/Psych.png" width="600" />
                            <div class="p-4">
                                <h3 class="text-xl font-bold mb-2">心理咨询</h3>
                                <p class="text-gray-600">Psychological Counseling</p>
                                <ul class="mt-2 text-gray-600">
                                    <li>轻度情感疗愈助手</li>
                                    <li>多模态心理健康测评</li>
                                    <li>咨询师助手</li>
                                    <li>AI 智能情绪教练</li>
                                    <li>专属AI心理咨询师</li>
                                </ul>
                            </div>
                        </div>
                        <div class="bg-white rounded-lg shadow-lg overflow-hidden">
                            <img alt="A person typing on a laptop" class="w-full h-48 object-cover" height="400"
                                 src="@/assets/Medical.png" width="600" />
                            <div class="p-4">
                                <h3 class="text-xl font-bold mb-2">医疗健康</h3>
                                <p class="text-gray-600">HealthCare</p>
                                <ul class="mt-2 text-gray-600">
                                    <li>医患沟通心理小助手</li>
                                    <li>患者情绪监测</li>
                                    <li>智能康复情绪支持</li>
                                    <li>智能心理诊疗</li>
                                    <li>AI健康顾问</li>
                                </ul>
                            </div>
                        </div>
                        <div class="bg-white rounded-lg shadow-lg overflow-hidden">
                            <img alt="A person writing in a notebook" class="w-full h-48 object-cover" height="400"
                                 src="@/assets/Business.png" width="600" />
                            <div class="p-4">
                                <h3 class="text-xl font-bold mb-2">企业管理</h3>
                                <p class="text-gray-600">Business Management</p>
                                <ul class="mt-2 text-gray-600">
                                    <li>AI心理面试官</li>
                                    <li>EAP项目智能助手</li>
                                    <li>职场沟通心理小助手</li>
                                    <li>智能压力管理助手</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
                <el-dialog :visible.sync="loginForm.dialogFormVisible" :width="dialogWidth" title="登录">
                    <el-form :model="loginForm" label-position="top" ref="loginForm">
                        <el-form-item label="手机号" :error="loginForm.phoneError">
                            <el-input placeholder="请输入手机号" v-model="loginForm.phone" @blur="validateLoginPhone"
                                      @input="validateLoginPhone" maxlength="11">
                                <template #prepend="">
                                    <el-select placeholder="+86" disabled style="width: 80px;"
                                               v-model="loginForm.phonePrefix">
                                        <el-option label="+86" value="+86" />
                                    </el-select>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="输入验证码" :error="loginForm.verificationCodeError">
                            <el-input placeholder="请输入验证码" v-model="loginForm.verificationCode"
                                      @blur="validateLoginVerificationCode" @input="validateLoginVerificationCode"
                                      maxlength="6">
                                <template #append="">
                                    <el-button @click="getVerificationCode('loginForm')"
                                               :disabled="loginForm.isCountingDown" type="primary">
                                        {{
                                        loginForm.verificationButtonText
                                        }}
                                    </el-button>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="submitLoginForm" class="w-full bg-primary"
                                       type="primary">立即登录</el-button>
                        </el-form-item>
                    </el-form>
                    <p class="text-center mt-4">
                        没有账号？
                        <el-link type="primary" @click="showRegister">立即注册</el-link>
                    </p>
                </el-dialog>
                <el-dialog :visible.sync="form.dialogFormVisible" :width="dialogWidth" title="注册">
                    <el-form :model="form" label-position="top" ref="form">
                        <el-form-item label="手机号" :error="form.phoneError">
                            <el-input placeholder="请输入手机号" v-model="form.phone" @blur="validatePhone"
                                      @input="validatePhone" maxlength="11">
                                <template #prepend="">
                                    <el-select placeholder="+86" disabled style="width: 80px;"
                                               v-model="form.phonePrefix">
                                        <el-option label="+86" value="+86" />
                                    </el-select>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="输入验证码" :error="form.verificationCodeError">
                            <el-input placeholder="请输入验证码" v-model="form.verificationCode"
                                      @blur="validateVerificationCode" @input="validateVerificationCode" maxlength="6">
                                <template #append="">
                                    <el-button @click="getVerificationCode('form')" :disabled="form.isCountingDown"
                                               type="primary">{{ form.verificationButtonText }}</el-button>
                                </template>
                            </el-input>
                        </el-form-item>
                        <el-form-item label="昵称" :error="form.nicknameError">
                            <el-input placeholder="请输入 20 字符内的昵称" v-model="form.nickname" @blur="validateNickname"
                                      @input="validateNickname" maxlength="20"></el-input>
                        </el-form-item>
                        <el-form-item :error="form.agreementError">
                            <el-checkbox v-model="form.agreement">
                                我已阅读并同意
                                <el-link href="#" type="primary">《用户协议》</el-link>
                                与
                                <el-link href="#" type="primary">《隐私政策》</el-link>
                            </el-checkbox>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="submitForm" class="w-full bg-primary" type="primary">立即注册</el-button>
                        </el-form-item>
                    </el-form>
                    <p class="text-center mt-4">
                        已有账号？
                        <el-link type="primary" @click="showLogin">直接登录</el-link>
                    </p>
                </el-dialog>
            </main>
            <footer class="py-1 border-t" id="footerui">
                <div class="flex justify-center items-center h-screen">
                    <div class="text-center">
                        <img alt="Company Logo" class="mx-auto mb-1" height="100" src="@/assets/logo.png"
                             width="80" />
                        <div class="text-xl font-bold text-gray-800 mb-4">识心智能</div>
                        <div class="flex justify-center flex-row space-x-0 md:space-x-16 mb-8">
                            <div class="text-center">
                                <div class="text-gray-600 mb-4">微信公众号</div>
                                <img alt="WeChat QR Code" class="mx-auto" height="100" src="@/assets/sxgzh.png"
                                     width="100" />
                            </div>
                            <div class="text-center">
                                <div class="text-gray-600 mb-4">视频号</div>
                                <img alt="AiU QR Code" class="mx-auto" height="100" src="@/assets/sxsph.png"
                                     width="100" />
                            </div>
                            <div class="text-center">
                                <div class="text-gray-600 mb-4">订阅号</div>
                                <img alt="Subscription QR Code" class="mx-auto" height="100" src="@/assets/subscription.jpg"
                                     width="100" />
                            </div>
                        </div>
                        <div class="text-gray-600 mb-3">公司名称：北京识心智能科技有限公司</div>
                        <div class="text-gray-600 mb-3">企业邮箱： tech@shixinai.com</div>
                        <div class="text-gray-600 mb-8">Copyright © 2024 北京识心智能科技有限公司 版权所有 | 京ICP备2024091482号-1</div>
                    </div>
                </div>
            </footer>
        </div>
    </body>
</template>
<script>
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
    import CommonHeader from './subassembly/CommonHeader.vue';
    export default {
        components: {
            CommonHeader,
        },
    name: 'HomePage',
    metaInfo: {
        title: '识心智能 - 首页',
        meta: [
            {
                name: 'description',
                content: '识心智能官网，各行各业量身定制专属的智能心理健康解决方案，以AI科技的力量促进心理健康事业的创新与繁荣发展'
            },
            {
                name: 'keywords',
                content: '识心智能, 心理健康, 心理健康AI, 心理AI, 健康AI, 心理健康方案, 声音疗愈, 智慧校园, 校园心理, 咨询师AI助手'
            }
        ]
    },
    watch: {
        '$route.hash'(newHash) {
            if (newHash) {
                const element = document.querySelector(newHash)
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' })
                }
            }
        }
    },
    data() {
        return {
            isLoggedInState: false,
            isUserMenuVisible: false,
            user: {},
            form: {
                dialogFormVisible: false,
                phone: '',
                phonePrefix: '+86',
                verificationCode: '',
                nickname: '',
                birthday: '',
                gender: '',
                invitationCode: '',
                agreement: false,
                phoneError: '',
                verificationCodeError: '',
                nicknameError: '',
                agreementError: '',
                isCountingDown: false,
                countdown: 60,
                verificationButtonText: '获取验证码'
            },
            loginForm: {
                dialogFormVisible: false,
                phonePrefix: '+86',
                phone: '',
                verificationCode: '',
                phoneError: '',
                verificationCodeError: '',
                isCountingDown: false,
                countdown: 60,
                verificationButtonText: '获取验证码'
            },
            registrationMessage: '',
            loginMessage: '',
            dialogWidth: '30%',
            showMenu: false, // 控制导航选项的显示状态
        };
    },
    mounted() {
        this.updateDialogWidth();
        window.addEventListener('resize', this.updateDialogWidth);
            // 初始加载时检查锚点
            this.handleAnchorScroll(this.$route)

            // 监听路由变化（用户点击回退时触发）
            this.$watch('$route', this.handleAnchorScroll)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateDialogWidth);
    },
    methods: {
        handleAnchorScroll(route) {
            if (route.hash) {
                console.log("=3333")
                setTimeout(() => {
                    const el = document.querySelector(route.hash)
                    if (el) el.scrollIntoView({ behavior: 'smooth' })
                }, 100)
            }
        },
        updateDialogWidth() {
            if (window.innerWidth <= 1000) {
                this.dialogWidth = '90%';
            } else {
                this.dialogWidth = '30%';
            }
        },
        isLoggedIn() {
            return !!localStorage.getItem('token');
        },
        showUserMenu() {
            this.isUserMenuVisible = true;
        },
        hideUserMenu() {
            this.isUserMenuVisible = false;
        },
        showRegister() {
            this.loginForm.dialogFormVisible = false;
            this.form.dialogFormVisible = true;
        },
        showLogin() {
            this.form.dialogFormVisible = false;
            this.loginForm.dialogFormVisible = true;
        },
        beginTrial() {
            
            if (this.isLoggedIn()) {
                //this.$router.push({ name: 'ChatOne' });
                window.open("http://47.92.88.250:8001/chatbot/V0uV50qirXiTAYaw", "_blank");
            } else {
                this.form.dialogFormVisible = false;
                this.loginForm.dialogFormVisible = true;
            }
        },
        logout() {
            localStorage.removeItem('token');
            this.user = {};
            this.isLoggedInState = false;
            this.$message({
                message: '登出成功',
                type: 'success'
            });
        },
        validatePhone() {
            const phoneRegex = /^[0-9]{11}$/;
            if (!phoneRegex.test(this.form.phone)) {
                this.form.phoneError = '请输入有效的11位手机号';
            } else {
                this.form.phoneError = '';
            }
        },
        validateVerificationCode() {
            if (!this.form.verificationCode) {
                this.form.verificationCodeError = '验证码不能为空';
            } else if (!/^[0-9]{6}$/.test(this.form.verificationCode)) {
                this.form.verificationCodeError = '请输入6位数字验证码';
            } else {
                this.form.verificationCodeError = '';
            }
        },
        validateNickname() {
            if (!this.form.nickname) {
                this.form.nicknameError = '昵称不能为空';
            } else if (this.form.nickname.length > 20) {
                this.form.nicknameError = '昵称长度不能超过20个字符';
            } else {
                this.form.nicknameError = '';
            }
        },
        validateAgreement() {
            if (!this.form.agreement) {
                this.form.agreementError = '请阅读并同意用户协议和隐私政策';
            } else {
                this.form.agreementError = '';
            }
        },
        saveAuthData(response) {
            // 保存 token 和用户信息到 localStorage
            if (response.data.token) {
                localStorage.setItem('token', response.data.token);
            }
        },
        async submitForm() {
            this.validatePhone();
            this.validateVerificationCode();
            this.validateNickname();
            this.validateAgreement();

            if (this.form.phoneError || this.form.verificationCodeError || this.form.nicknameError || this.form.agreementError) {
                return;
            }

            try {
                const payload = {
                    phone: this.form.phone,
                    nickname: this.form.nickname,
                    birthday: this.form.birthday,
                    gender: this.form.gender,
                    verificationCode: this.form.verificationCode
                };
                const response = await axios.post('/api/register', payload, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                this.$message({
                    message: response.data.message,
                    type: response.data.type
                });
                this.registrationMessage = response.data.message;
                this.form.dialogFormVisible = false;
                if (response.data.token) {
                    this.saveAuthData(response);
                    // 查询用户信息
                    await this.checkTokenAndFetchUserInfo();
                }
            } catch (error) {
                console.error('Registration failed:', error);
                this.registrationMessage = 'Registration failed. Please try again.';
            }
        },
        validateLoginPhone() {
            const phoneRegex = /^[0-9]{11}$/;
            if (!phoneRegex.test(this.loginForm.phone)) {
                this.loginForm.phoneError = '请输入有效的11位手机号';
            } else {
                this.loginForm.phoneError = '';
            }
        },
        validateLoginVerificationCode() {
            if (!this.loginForm.verificationCode) {
                this.loginForm.verificationCodeError = '验证码不能为空';
            } else if (!/^[0-9]{6}$/.test(this.loginForm.verificationCode)) {
                this.loginForm.verificationCodeError = '请输入6位数字验证码';
            } else {
                this.loginForm.verificationCodeError = '';
            }
        },
        async submitLoginForm() {
            this.validateLoginPhone();
            this.validateLoginVerificationCode();

            if (this.loginForm.phoneError || this.loginForm.verificationCodeError) {
                return;
            }

            try {
                const payload = {
                    phone: this.loginForm.phone,
                    verificationCode: this.loginForm.verificationCode
                };
                const response = await axios.post('/api/login', payload, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                this.$message({
                    message: response.data.message,
                    type: response.data.type
                });
                console.log('Login successful:', response.data);
                this.loginMessage = response.data.message;
                this.loginForm.dialogFormVisible = false;
                if (response.data.token) {
                    this.saveAuthData(response);
                    // 查询用户信息
                    await this.checkTokenAndFetchUserInfo();
                }
            } catch (error) {
                console.error('Login failed:', error);
                this.loginMessage = 'Login failed. Please try again.';
            }
        },
        async getVerificationCode(formType) {
            const form = this[formType];
            this.validatePhone();
            if (form.phoneError) {
                this.$message({
                    message: form.phoneError,
                    type: 'error'
                });
                return;
            }

            try {
                const response = await axios.post('/api/get_verification_code', {
                    phone: form.phone,
                    type: formType === 'form' ? 'register' : 'login'
                }, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });
                console.log('Verification code sent:', response.data);
                this.$message({
                    message: response.data.message,
                    type: response.data.type
                });
                this.startCountdown(formType);
            } catch (error) {
                console.error('Failed to get verification code:', error);
                this.$message({
                    message: '获取验证码失败，请重试',
                    type: 'error'
                });
            }
        },
        startCountdown(formType) {
            const form = this[formType];
            form.isCountingDown = true;
            form.countdown = 60;
            form.verificationButtonText = `${form.countdown}s`;
            const interval = setInterval(() => {
                form.countdown -= 1;
                if (form.countdown > 0) {
                    form.verificationButtonText = `${form.countdown}s`;
                } else {
                    clearInterval(interval);
                    form.verificationButtonText = '获取验证码';
                    form.isCountingDown = false;
                }
            }, 1000);
        },
        async checkTokenAndFetchUserInfo() {
            const token = localStorage.getItem('token');
            if (token) {
                try {
                    const decodedToken = jwtDecode(token);
                    const currentTime = Date.now() / 1000; // 当前时间的秒数
                    // const expDate = new Date(decodedToken.exp * 1000).toLocaleString();
                    // const currentDate = new Date(currentTime * 1000).toLocaleString();
                    // console.log('Token decoded.exp:', expDate, 'currentTime:', currentDate);

                    if (decodedToken.exp > currentTime) {
                        // Token 未过期，查询用户信息
                        const response = await axios.get(`/api/users/${decodedToken.user_id}`, {
                            headers: {
                                'Authorization': `Bearer ${token}`
                            }
                        });
                        this.user = response.data;
                        this.isLoggedInState = true;
                    } else {
                        // Token 已过期，清除本地存储
                        localStorage.removeItem('token');
                    }
                } catch (error) {
                    console.error('Token 解析失败或用户信息查询失败:', error);
                    localStorage.removeItem('token');
                }
            }
        },
        async updateToken() {
            const token = localStorage.getItem('token');
            if (token) {
                try {
                    const response = await axios.post('/api/refresh_token', {}, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        }
                    });
                    const newToken = response.data.token;
                    localStorage.setItem('token', newToken);
                } catch (error) {
                    console.error('Failed to update token:', error);
                }
            }
        },
    },
    created() {
        this.checkTokenAndFetchUserInfo();
        //this.updateToken();
    }
};
</script>

<style>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css');
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+SC:wght@400;500;700&display=swap');
@import url('https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css');
ul {
    list-style: none; /* 去掉默认的列表样式 */
}
body {
    font-family: 'Noto Sans SC', sans-serif;
}
    /* 卡片悬停效果 */
    .feature-card {
        transition: all 0.3s ease;
    }

        .feature-card:hover {
            transform: translateY(-8px);
        }
</style>
